<template>
  <div class="row">
    <div class="col-xs-6">
      <div class="text-left">
        <button
          id="stepPrevious"
          type="button"
          class="btn btn-default"
          @click.prevent="prevStep(currentFormType)"
        >
          Previous
        </button>
      </div>
    </div>

    <div class="col-xs-6">
      <div class="text-right">
        <button
          v-if="currentStep != 2"
          id="stepNext"
          type="button"
          class="btn btn-success active"
          @click.prevent="nextStep(currentFormType)"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentFormType() {
      return this.$store.state.registration.type;
    },
    currentStep() {
      return this.$store.state.registration.step;
    },
    npiCheckedStatus() {
      return this.$store.state.registration.npi_checked;
    },
    getNpiInfo() {
      return this.$store.state.registration.npi_info;
    },
  },
  methods: {
    nextStep(formType) {
      if (this.npiCheckedStatus) {
        this.$store.dispatch("nextStep");
        this.$store.dispatch("setFormType", formType);
      } else {
        this.fireAlert();
      }
    },
    prevStep(formType) {
      this.$store.dispatch("prevStep");
      this.$store.dispatch("setFormType", formType);
    },
    fireAlert() {
      // eslint-disable-next-line no-undef
      swal.fire({
        title: "Select one option please.",
        type: "warning",
        text:
          "If you are not a medical professional. Select I am not a medical professional or have not been issued an NPI number",
        showCancelButton: false,
        showConfirmButton: true,
      });
    },
  },
};
</script>
